import React, { useState } from "react";
import { convertStringToArray } from "../../../../Utils/utils";
import Viewer from "react-viewer";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";
import { useTableResponsive } from "../../../../hooks/useTableResponsive";
import PdfZipItem from "../../../../components/PdfZipItem";
import { imageUrl } from "../../../../constants/constants";

const CsrActivities = ({ data }) => {
  const { getText } = useLanguageTranslation();
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: imageUrl + img.file_path,
        alt: img.title,
      })),
    );
    setActiveIndex(index);
    setVisible(true);
  };
  useTableResponsive(data);

  // convert string into pdf array
  const pdfArray = convertStringToArray(data?.field_download);

  // convert string into images array
  const imagesArray = convertStringToArray(data?.field_events_image);

  return (
    <>
      {/* <!--content section start here--> */}
      <div className="mt-4">
        {/* <h2 className="title2">Our Approach</h2> */}
        <h2 className="title3">{data?.title}</h2>
      </div>
      <div className="table-responsive">
        <table className="table table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Description", "विवरण")}</th>
              <th>{getText("Download", "डाउनलोड")}</th>
            </tr>
          </thead>
          <tbody>
            {pdfArray.map((item, index) => (
              <tr key={index}>
                <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                <td data-key={getText("Description", "विवरण")}>{item.title}</td>
                <td data-key={getText("Download", "डाउनलोड")}>
                  <PdfZipItem filePath={item?.file_path} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-4">
        <div className="title-sec">
          <h2>{getText("Photo Gallery", "फोटो गैलरी")}</h2>
        </div>
        <div className="row">
          {imagesArray?.map((photo, index) => (
            <div
              className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4"
              key={index}
            >
              <a
                onClick={() => {
                  openViewer(imagesArray, index);
                }}
              >
                <div
                  className="card-sec wow zoomIn"
                  style={{
                    visibility: "visible",
                    animationName: "zoomIn",
                  }}
                >
                  <div className="img-sec">
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_IMAGE_URL}/${photo.file_path}`}
                    />
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>

      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
};

export default CsrActivities;
